import { render, staticRenderFns } from "./DialogAddLei.vue?vue&type=template&id=197b07e9&scoped=true&"
import script from "./DialogAddLei.vue?vue&type=script&lang=js&"
export * from "./DialogAddLei.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddLei.vue?vue&type=style&index=0&id=197b07e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b07e9",
  null
  
)

export default component.exports